module.exports = __webpack_public_path__ + "img/hyzl_bg2.fe653523.png";